module.exports = __webpack_public_path__ + "img/3.7c13cc7e.jpg";